import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectProductTabsModelId } from 'src/features/stock-management/StockManagementSeletor'
import { actions } from 'src/features/stock-management/StockManagementState'
import * as S from './BarcodesTab.styles'
import BarcodesTable from './components/BarcodesTable'

export default () => {
  const dispatch = useDispatch()
  const modelId = useSelector(selectProductTabsModelId)

  useEffect(() => {
    if (!modelId) {
      return
    }
    dispatch(actions.getProductBarcodes())
  }, [dispatch, modelId])

  return (
    <S.Wrapper>
      <BarcodesTable />
    </S.Wrapper>
  )
}
